import { useCaseStudyStore } from '@app/stores/CaseStudyStore'

// This mixin is for common functionality of case study sections.
export default {
  methods: {
    updateSection(event) {
      const el = event.target
      const fieldName = el.getAttribute('name')
      const newContent = el.innerText
      const newSection = { ...this.section, [fieldName]: newContent }
      useCaseStudyStore().updateSection(this.caseStudyId, this.index, newSection)

      el.blur()
    },
    updateByField(fieldName) {
      return (newContent) => {
        const newSection = { ...this.section, [fieldName]: newContent }
        useCaseStudyStore().updateSection(this.caseStudyId, this.index, newSection)
      }
    },
  },
}
